"use client";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ImageHeading from "../components/ui/ImageHeading";
import GlobalTitle from "../components/shared/GlobalTitle";
import headerImage from "../assets/header/header2.jpeg";
import useAxiosPublic from "../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../components/Layout/LoadingPage";

const LifeAtZums = () => {
  const axiosPublic = useAxiosPublic();

  const {
    data: lifeAtZumsApiData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["life-at-zums"],
    queryFn: async () => {
      const res = await axiosPublic.get("/life-at-zums");
      return res?.data?.data;
    },
  });

  if (isLoading) return <LoadingPage />;

  if (error)
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );

  return (
    <div className="min-h-screen bg-white">
      <ImageHeading heading="Life At ZUMS" imageUrl={headerImage} />

      {lifeAtZumsApiData?.galleries?.map((section, index) => (
        <section
          key={section.id}
          className="container px-4 py-2 mx-auto lg:py-12 sm:px-6 lg:px-8"
        >
          <div
            className={`flex flex-col ${
              index % 2 === 0 ? "lg:flex-row-reverse" : "lg:flex-row"
            } items-center`}
          >
            {/* Image */}
            <motion.div
              className="relative w-full h-auto col-span-2 border-2 border-primary aspect-video md:w-2/3 cursor-pointer group"
              whileInView={{ opacity: 1, x: 0, transition: { duration: 0.8 } }}
              initial={{ opacity: 0, x: index % 2 === 0 ? 100 : -100 }}
              viewport={{ once: false }}
            >
              <Link
                to={`/life-at-zums/${section.id}`}
                state={section} // pass data to new page
              >
                <img
                  src={section.gallery_url[0] || "/placeholder.svg"}
                  className={`absolute inset-0 object-cover object-center w-full h-full top-4 ${
                    index % 2 === 0 ? "-left-4" : "left-4"
                  }`}
                  alt={section?.title}
                />
                <div className="absolute inset-0 flex items-center justify-center transition-opacity duration-300 bg-black/50 opacity-0 group-hover:opacity-100">
                  <span className="px-4 py-2 text-white bg-primary rounded-md">
                    View Gallery
                  </span>
                </div>
              </Link>
            </motion.div>

            {/* Text content */}
            <motion.div
              className="z-20 w-full p-12 bg-white lg:w-1/3"
              whileInView={{ opacity: 1, x: 0, transition: { duration: 0.8 } }}
              initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
              viewport={{ once: false }}
            >
              <GlobalTitle title={section?.title} />
              <p className="mt-8 text-gray-700">{section.description}</p>
            </motion.div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default LifeAtZums;
